<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="NewsSetting-container full-height">
    <div v-if="checkPermission(['ITA-DEV', 'ITA-ADMIN', 'ITA-ADM-STAFF', 'ITA-SALES'])">
      <el-card class="box-card" v-loading="loading">
        <div slot="header" class="clearfix">
          <span>最新消息設定❗</span>
          <el-button style="float: right; color: #4b4b4b" type="warning" @click="saveData"
            >儲 存</el-button
          >
        </div>
        <div>
          <el-tabs v-model="tabName" type="border-card">
            <el-tab-pane label="編輯" name="edit">
              <div>
                <tinymce
                  v-model="content"
                  :id="`tinymcePlan_newsSetting`"
                  ref="tinymce_newsSetting"
                  :height="500"
                  style="position: relative"
                  :type="33"
                />
              </div>
            </el-tab-pane>
            <el-tab-pane label="預覽" name="preview">
              <div style="height: 100%">
                <div v-html="content" class="full-height bg-text"></div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-card>
    </div>
    <!-- <div
      v-else
      class="view-div full-height"
      :style="{ backgroundImage: 'url(' + teaching + ')' }"
    > -->
    <div v-else class="view-div full-height">
      <div class="bg-image"></div>

      <div class="bg-text">
        <p v-html="content"></p>
      </div>
    </div>
  </div>
</template>

<script>
import italogo from '@/assets/images/italogo.png'
import teaching from '@/assets/images/teaching.png'
import Tinymce from '@/components/Tinymce'
import { getNewsSetting, saveNewsSetting } from '@/api/unity'
import { htmlEncode, htmlDecode } from '@/utils/funcs'
import checkPermission from '@/utils/permission' // 权限判断函数

export default {
  name: 'NewsSetting',
  components: {
    Tinymce,
  },
  data() {
    return {
      italogo: '',
      teaching: '',
      loading: false,
      tabName: 'edit',
      list: null,
      content: '',
    }
  },
  async created() {
    this.italogo = italogo
    this.teaching = teaching
    await this.getData()
  },
  methods: {
    checkPermission,
    async getData() {
      this.loading = true
      try {
        let resp = await getNewsSetting()
        if (resp.data) {
          this.content = htmlDecode(resp.data.content)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async saveData() {
      if (!confirm(`確定要存檔?`)) {
        return
      }
      this.loading = true
      try {
        let resp = await saveNewsSetting({
          content: htmlEncode(this.content),
        })
        console.log(resp)
        if (resp.success) {
          this.$message({
            message: '儲存成功',
            type: 'success',
          })
          await this.getData()
        } else {
          this.$message({
            message: '儲存失敗',
            type: 'error',
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.full-height {
  position: relative;
  height: 100%;
}

.el-card__header {
  padding: 15px !important;
}

.view-div {
}

.bg-image {
  /* The image used */
  /* Add the blur effect */
  /* filter: blur(8px);
  -webkit-filter: blur(8px); */

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: 300px 280px;

  /* background-size: cover; */
}

/* Position text in the middle of the page/image */
.bg-text {
  overflow: auto;
  height: 90%;
  /* background-color: rgba(0, 17, 17, 0.3); */
  background-color: white;
  /* Fallback color */
  /* background-color: rgb(0, 0, 0); */
  /* Black w/opacity/see-through */
  /* background-color: rgba(0, 0, 0, 0.4); */
  color: white;
  border: 3px solid #f1f1f1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 90%;
  padding: 15px;
  /* text-align: center; */
}

.el-tabs--card {
  height: calc(100vh - 110px);
  /* overflow-y: auto; */
}

.el-tab-pane {
  height: calc(100vh - 110px);
  overflow-y: auto;
}
</style>
